import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { USDT } from '../../../helpers/helperFunctions';
import { H2, H3, P3 } from '../../../styles/FontStyles';
import { Box, Button, CheckIconBox } from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { Icon, IconPackagesCheck } from '../../../styles/Icons';
import { FlexBetween, FlexCenter } from '../../../styles/stylesStyled';

interface VirtualOfficeCard {
  plan: any;
  setSelected: Dispatch<SetStateAction<any>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  setStep: Dispatch<SetStateAction<number>>;
}

export const VirtualOfficeCard = ({
  plan,
  setIsOpen,
  setSelected,
  setStep
}: // setSelectedHub
VirtualOfficeCard) => {
  const { t } = useTranslation('settings');

  return (
    <Box>
      <FlexBetween>
        <P3 bold>{plan.title}</P3>
        {plan.id === 3 && (
          <P3 color={color.colors.secondary100} bold>
            {t('virtual_office.plans.most_popular')}
          </P3>
        )}
      </FlexBetween>
      <H2 bold style={{ margin: '10px 0 15px 0' }}>
        ${plan.price} {USDT}
      </H2>

      {plan.benefits.map((benefit: any, i: any) => (
        <div style={{ marginBottom: 10 }} key={i}>
          <FlexCenter>
            <CheckIconBox background={benefit.text === ''}>
              <Icon>
                <IconPackagesCheck />
              </Icon>
            </CheckIconBox>
            <P3>{benefit.text}</P3>
          </FlexCenter>
        </div>
      ))}

      <H3
        style={{ visibility: !plan.save ? 'hidden' : 'visible' }}
        color={colors.primary900}
        center>
        {`${t('virtual_office.plans.save')} ${plan.save || '00'}%`}
      </H3>
      <Button
        w='100%'
        mt='15'
        onClick={() => {
          setSelected(plan);
          setIsOpen(true);
          setStep(1);
        }}>
        {t('virtual_office.plans.plan_access', { access: plan.access })}
      </Button>
    </Box>
  );
};
